import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.cluster.DOC}
  query SpaceCluster(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                cluster(id: $clusterId) {
                  ...FragmentSpaceCluster
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.SpaceClusterQuery,
  ents.extra.space.Cluster | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'space',
            graphql.transformers.OUT.select(
              'cluster',
              fragments.cluster.TRANSFORMER,
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceClusterQuery,
  ents.extra.space.Cluster | undefined,
  graphql.schema.SpaceClusterQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
